const ERRORS = {
    USER_NOT_FOUND: 'Usuário não encontrado!', 

    PLAN_NOT_FOUND: 'Plano não encontrado!',
    PLAN_BELONGS_TO_GROUP: 'Plano compõe algum grupo de planos!',

    PLAN_GROUP_NOT_FOUND: 'Grupo de planos não encontrado!',
    DEFAULT_PLAN_GROUP: 'Grupo de planos padrão!'
}

export default ERRORS